import { t } from 'i18next';

import { InterviewStatus } from '@/services/api';

export type StatusFilterItem = {
  name: InterviewStatus;
  text: string;
};

/**
 * Shared status filter items with consistent ordering and translations.
 * Ordered by logical workflow progression: initial states → active states → final states.
 */
export const statusFilterItems: Array<StatusFilterItem> = [
  // Initial states
  {
    name: InterviewStatus.Added,
    text: t('components:status.added'),
  },
  {
    name: InterviewStatus.Invited,
    text: t('components:status.invited'),
  },

  // Active/In-progress states
  {
    name: InterviewStatus.NotCompleted,
    text: t('components:status.notCompleted'),
  },
  {
    name: InterviewStatus.Completed,
    text: t('components:status.completed'),
  },
  {
    name: InterviewStatus.Evaluated,
    text: t('components:status.evaluated'),
  },
  {
    name: InterviewStatus.Pending,
    text: t('components:status.pending'),
  },
  {
    name: InterviewStatus.Paused,
    text: t('interview:status.paused'),
  },
  {
    name: InterviewStatus.ActionRequired,
    text: t('interview:status.actionRequired'),
  },

  // Evaluation results
  {
    name: InterviewStatus.Positive,
    text: t('components:status.positive'),
  },
  {
    name: InterviewStatus.Negative,
    text: t('components:status.negative'),
  },

  // Internal process states
  {
    name: InterviewStatus.InternalProcess,
    text: t('interview:statuses.statusInternalProcess'),
  },
  {
    name: InterviewStatus.InternalProcessTwo,
    text: t('interview:statuses.statusInternalProcessTwo'),
  },
  {
    name: InterviewStatus.SentAgain,
    text: t('interview:statuses.statusSentAgain'),
  },
  {
    name: InterviewStatus.PreliminaryCompleted,
    text: t('interview:statuses.statusPreliminaryCompleted'),
  },

  // Offer states
  {
    name: InterviewStatus.OfferSent,
    text: t('interview:statuses.statusOfferSent'),
  },
  {
    name: InterviewStatus.OfferAccepted,
    text: t('interview:statuses.statusOfferAccepted'),
  },
  {
    name: InterviewStatus.OfferRejected,
    text: t('interview:statuses.statusOfferRejected'),
  },

  // Final states
  {
    name: InterviewStatus.Hired,
    text: t('components:status.hired'),
  },
  {
    name: InterviewStatus.ReferenceCheck,
    text: t('interview:statuses.statusReferenceCheck'),
  },
  {
    name: InterviewStatus.NotInterested,
    text: t('interview:statuses.statusNotInterested'),
  },
  {
    name: InterviewStatus.Withdrawn,
    text: t('interview:statuses.statusWithdrawn'),
  },
];
